import { MainComponent } from './pages/main/main.component';
import { MAIN_ROUTES } from './pages/main/main.routes';

export const MAIN_MAIN_ROUTES = [
    {
        path: 'main',
        component: MainComponent,
        children: MAIN_ROUTES,
        resolve: {
            // references: ReferencesResolver
        }
    }
];
